import axios from '@/services/axios';

const apiService = {
  get(resource: any, params?: any) {
    return axios.get(`/${resource}`, params);
  },

  post(resource: any, params?: any, config?: any) {
    return axios.post(`/${resource}`, params, config);
  },

  update(resource: any, slug: any, params?: any) {
    return axios.put(`/${resource}/${slug}`, params);
  },

  put(resource: any, params?: any) {
    return axios.put(`/${resource}`, params);
  },

  delete(resource: any, params?: any) {
    return axios.delete(`/${resource}`, params);
  },
};
export default apiService;
